import {Button} from "antd";
import cn from "classnames/bind";
import {Close, Open} from "./icons";
import {useAuth} from "@/lib/hook";
import {useState} from "react";
import {signOut} from "next-auth/react";
import {api} from "@/lib/api/api";
import {useRouter} from "next/navigation";
import {myLinks} from "@/lib/routes/myLinks";
import {OptionButton} from "@/theme";

export const ToggleButton = ({collapsed, setCollapsed, collapsedHover, mobile}) => {
    const auth = useAuth()
    const router = useRouter()
    const [preLoad, setPreLoad] = useState(false)

    const onClickSignOut = () =>{
        setPreLoad(true)
        api.send({
            route: {name: 'auth.logout'},
        }).then(()=>{
            signOut({
                redirect: false
            }).then(()=>{
                router.push(myLinks.getUlr('sign-in'))
            })
        }).finally(()=>{
            setPreLoad(false)
        })
    }

    return (
        <div
            className={cn('toggle_sidebar', {['mobile']: mobile})}
        >
            <div className={'wrapper'}>
                <div className={cn('auth', {['show']: !collapsedHover})}>
                    <div>
                        <div className={'name'}>
                            {auth.user.first_name} {auth.user.last_name}
                        </div>
                        <div className={'email'}>
                            {auth.user.email}
                        </div>
                    </div>

                    <div className={'options'}>
                        <OptionButton
                            trigger={'hover'}
                        >
                            <OptionButton.Button>
                                <Button
                                    style={{
                                        width: '100%'
                                    }}
                                    type={'text'}
                                    onClick={onClickSignOut}
                                    disabled={preLoad}
                                >
                                    Sign Out
                                </Button>
                            </OptionButton.Button>
                        </OptionButton>
                    </div>
                </div>

                {(!mobile) && (
                    <div>
                        <Button
                            type="text"
                            icon={collapsed ? <Close /> : <Open />}
                            onClick={() => setCollapsed(!collapsed)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}